<main class="contenido-principal-productos">
    <section class="hero-productos">
        <div class="contenedor">
            <div class="imagen-hero-productos"></div>
            <div class="texto-hero-productos contenedor-blanco">
                <div class="circulo-azul-hero circulo-azul-decorativo"></div>
                <h1 class="titulo-principal">Nuestros productos</h1>
                <p class="parrafo-contenido">En <strong>Corporación Rehobot</strong> ponemos a disposición de nuestros clientes una línea completa de productos industriales, eléctricos y de automatización, orientada a cubrir las necesidades de abastecimiento del recurso hídrico en distintos sectores económicos y de infraestructura del país. Somos representantes autorizados de las mejores marcas internacionales <strong>PENTAX, PEDROLLO, PANELLI, IDEAL, PENTAIR, CNP-NEMO, GRUNDFOS, EMALEX, LUXSE, ITAP</strong> y <strong>ITUR</strong> lo que garantiza la calidad de todo instrumento, maquinaria, energéticos y soporte técnico permanente.</p>
            </div>    
        </div>
    </section>

    <section class="seccion-productos-catalogo">
        <div class="contenedor">
            
            <div class="categorias-pestanas">
                <button *ngFor="let cat of categorias" 
                        class="pestana-categoria" 
                        [class.activa]="categoriaSeleccionadaId === cat.id"
                        (click)="cambiarCategoria(cat.id)">
                    {{ cat.nombre }}
                </button>
            </div>

            <div class="dropdown-categorias">
                <button class="dropdown-trigger" (click)="toggleDropdown()">
                    {{ categoriaActual?.nombre || 'VER PRODUCTOS' }}
                </button>
                <div class="dropdown-opciones" [class.mostrar]="dropdownAbierto">
                    <button *ngFor="let cat of categorias" 
                            class="opcion-categoria"
                            (click)="cambiarCategoria(cat.id)">
                        {{ cat.nombre }}
                    </button>
                </div>
            </div>

            <div class="contenedor-productos-completo">
                
                <div class="descripcion-categoria" *ngIf="categoriaActual">
                    <p [innerHTML]="categoriaActual.descripcion" class="descripcion-activa"></p>
                </div>

                <div class="contenido-productos-catalogo">
                    <div class="productos-grid activo">
                        
                        <div class="producto-card" *ngFor="let prod of productosMostrados">
                            <div class="producto-imagen">
                                <img [src]="prod.imagen" *ngIf="prod.imagen" [alt]="prod.nombre">
                            </div>
                            
                            <div class="producto-info">
                                <h3>{{ prod.nombre }}</h3>
                                <button class="btn-cotizar">
                                    <a routerLink="/contacto">Cotiza Aquí</a>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

            </div> 
        </div>
    </section>
</main>